const ErpAFSOrderSyncRetryAPI = async (URL, payload, accessToken) => {
    const responce = window.axios.post(URL, payload, {
    headers: {
      'Authorization': 'Bearer ' + accessToken,
    }}).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default ErpAFSOrderSyncRetryAPI;